import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { GmailEmailEntity, GmailThreadGetInput } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

export function useGmailThreadGet(
  connection: IntegrationConnection | null | undefined,
  input: GmailThreadGetInput = { thread_id: "" },
  options?: Partial<UseQueryOptions<{ data: GmailEmailEntity[] }, AxiosError>>,
) {
  return useQuery({
    queryKey: ["gmail-thread-get", connection?.id, input],
    queryFn: () => {
      if (!connection) {
        throw new Error("No Gmail connection available");
      }
      return orgAPI.toolbox.execute<GmailEmailEntity[]>({
        integration_connection_id: connection.id,
        action_name: "gmail-thread-get",
        action_input: {
          ...input,
        },
      });
    },
    enabled: !!connection && !!input.thread_id,
    ...options,
  });
}
